import { Col, Container, Row } from "react-bootstrap"
import projImg1 from "../assets/img/fox-free-icon-font.png"
import projImg2 from "../assets/img/beer-free-icon-font.png"
import projImg3 from "../assets/img/balloons-free-icon-font.png"
import projImg4 from "../assets/img/restaurant-free-icon-font.png"
import projImg5 from "../assets/img/video-camera-free-icon-font.png"
import projImg6 from "../assets/img/sword-free-icon-font.png"
import projImg7 from "../assets/img/christmas-bell.png"
import projImg8 from "../assets/img/santa.png"
import projImg9 from "../assets/img/musik-note.png"
import projImg10 from "../assets/img/handschlag.png"
import projImg11 from "../assets/img/ski.png"


export const Veranstaltungen = () => {

    return(

        <section className="veranstaltungen" id="veranstaltungen">
            <Container>
                <Row>
                    <Col>
                        <h2>Veranstaltungen</h2>
                        <br />
                        <h4>im Sommersemester 2026</h4>
                        <br />
                        <br />
                        <div className="eventBox">
                        <div className="eventBox1">
                            <img src={projImg10} alt="" />
                            <h4>SV Musikwochenende in Berlin</h4>
                            <h5>08.04.2026</h5>
                        </div>
                        <div className="eventBox2">
                            <img src={projImg10} alt="" />
                            <h4>Akademischer Vortrag</h4>
                            <h5>17.04.2026</h5>
                            <p>17:00</p>
                        </div>
                        <div className="eventBox3">
                            <img src={projImg2} alt="" />
                            <h4>Ankneipe</h4>
                            <h5>18.04.2026</h5>
                            <p>20:00 c.t.</p>
                        </div>
                        <div className="eventBox4">
                            <img src={projImg1} alt="" />
                            <h4>SV Fuxenwochenende in Münster</h4>
                            <h5>24.04.2026 bis 26.04.2026</h5>
                        </div>
                        </div>
                            <br />
                            <br />
                            <br />
                        <div className="eventBoxRow2">
                            <div className="eventBoxRow21">
                                <img src={projImg2} alt="" />
                                <h4>Sovietkneipe</h4>
                                <h5>01.05.2026</h5>
                                <p>20:00 c.t.</p>
                            </div>
                            <div className="eventBoxRow22">
                                <img src={projImg10} alt="" />
                                <h4>Stadtführung ehemaliger Arbeiterviertel</h4>
                                <h5>02.05.2026</h5>
                                <p>13:00</p>
                            </div>
                            <div className="eventBoxRow23">
                                <img src={projImg2} alt="" />
                                <h4>Boßeltour im Stadtpark</h4>
                                <h5>14.05.2026</h5>
                                <p>14:00</p>
                            </div>
                            <div className="eventBoxRow24">
                                <img src={projImg9} alt="" />
                                <h4>SV Songcontest in Frankfurt</h4>
                                <h5>15.05.2026 bis 17.05.2026</h5>
                            </div>
                        </div>

                        <br />
                            <br />
                            <br />
                        <div className="eventBoxRow3">
                            <div className="eventBoxRow31">
                                <img src={projImg5} alt="" />
                                <h4>Begrüßungsabend mit Galerie</h4>
                                <h5>22.05.2026</h5>
                                <p>18:00</p>
                            </div>
                            <div className="eventBoxRow32">
                                <img src={projImg9} alt="" />
                                <h4>Aktivenkonzert</h4>
                                <h5>23.05.2026</h5>
                                <p>14:00</p>
                            </div>
                            <div className="eventBoxRow33">
                                <img src={projImg2} alt="" />
                                <h4>Festkommers</h4>
                                <h5>23.05.2026</h5>
                                <p>20:00 c.t.</p>
                            </div>
                            <div className="eventBoxRow34">
                                <img src={projImg4} alt="" />
                                <h4>Frühschoppen</h4>
                                <h5>24.05.2026</h5>
                                <p>11:00</p>
                            </div>
                        </div>
                        <br />
                            <br />
                            <br />
                        <div className="eventBoxRow3">
                            <div className="eventBoxRow31">
                                <img src={projImg6} alt="" />
                                <h4>Kneipsportturnier</h4>
                                <h5>20.06.2026</h5>
                                <p>17:00</p>
                            </div>
                            <div className="eventBoxRow32">
                                <img src={projImg10} alt="" />
                                <h4>Konzertbesuch in Heimfeld</h4>
                                <h5>12.07.2026</h5>
                                <p>17:45</p>
                            </div>
                            <div className="eventBoxRow33">
                                <img src={projImg3} alt="" />
                                <h4>Semester Closing Party</h4>
                                <h5>18.07.2026</h5>
                                <p>22:00</p>
                            </div>
                            <div className="eventBoxRow34">
                                <img src={projImg2} alt="" />
                                <h4>Abkneipe</h4>
                                <h5>25.07.2026</h5>
                                <p>20:00 c.t.</p>
                            </div>
                        </div>
                        <br />
                            <br />
                            <br />
                        <div className="eventBoxRow3">
                            <div className="eventBoxRow31">
                                <img src={projImg10} alt="" />
                                <h4>Weinprobe</h4>
                                <h5>08.08.2026</h5>
                                <p>17:00</p>
                            </div>
                            <div className="eventBoxRow32">
                                <img src={projImg10} alt="" />
                                <h4>Wandern im Wohldorfer Wald</h4>
                                <h5>09.08.2026</h5>
                                <p>12:00</p>
                            </div>
                            <div className="eventBoxRow33">
                                <img src={projImg2} alt="" />
                                <h4>Stadtparkkneipe</h4>
                                <h5>22.08.2026</h5>
                                <p>15:00</p>
                            </div>
                            <div className="eventBoxRow34">
                                <img src={projImg9} alt="" />
                                <h4>SV Musenwochenende in Sondershausen</h4>
                                <h5>28.08.2026 bis 30.08.2026</h5>
                            </div>
                        </div>
                        <br />
                            <br />
                            <br />
                        <div className="eventBoxRow3">
                            <div className="eventBoxRow31">
                                <img src={projImg10} alt="" />
                                <h4>SV Rallye in Kiel</h4>
                                <h5>11.09.2026 bis 13.09.2026</h5>
                            </div>
                            <div className="eventBoxRow32">
                                <img src={projImg10} alt="" />
                                <h4>Biermimik-Workshop</h4>
                                <h5>19.09.2026</h5>
                            </div>
                            <div className="eventBoxRow33">
                                <img src={projImg4} alt="" />
                                <h4>Küchenschnack</h4>
                                <h5>TBA</h5>
                            </div>
                            <div className="eventBoxRow34">
                                <img src={projImg1} alt="" />
                                <h4>Fuxenstunden</h4>
                                <h5>nach Absprache</h5>
                            </div>
                        </div>
                        {/*<br />
                            <br />
                            <br />
                        <div className="eventBoxRow3">
                            <div className="eventBoxRow31">
                                <img src={projImg2} alt="" />
                                <h4>Bierbrauen</h4>
                                <h5>27.10.2023 bis 29.10.2023</h5>
                                <h5>&</h5>
                                <h5>17.11.2023 bis 19.11.2023</h5>
                            </div>
                            <div className="eventBoxRow32">
                                <img src={projImg10} alt="" />
                                <h4>OV-Stammtisch</h4>
                                <h5>2. Mittwoch im Monat</h5>
                            </div>
                            <div className="eventBoxRow33">
                                <img src={projImg9} alt="" />
                                <h4>Chorprobe</h4>
                                <h5>Jeden Montag</h5>
                                <p>19:00</p>
                            </div>
                            <div className="eventBoxRow34">
                                <img src={projImg4} alt="" />
                                <h4>Küchenschnack</h4>
                                <h5>TBA</h5>
                            </div>
                        </div>
*/}
{/*
                        <br />
                            <br />
                            <br />
                        <div className="eventBoxRow4">
                            <div className="eventBoxRow41">
                                <img src={projImg11} alt="" />
                                <h4>SV-Skipokal</h4>
                                <h5>10.02. bis 12.02.2023</h5>
                            </div>
                            <div className="eventBoxRow42">
                                <img src={projImg2} alt="" />
                                <h4>Abkneipe</h4>
                                <h5>25.02.2023</h5>
                                <p>20:00 c.t.</p>
                            </div>
                            <div className="eventBoxRow43">
                                <img src={projImg4} alt="" />
                                <h4>Küchenschnack</h4>
                                <h5>TBA</h5>
                            </div>
                            <div className="eventBoxRow44">
                                <img src={projImg1} alt="" />
                                <h4>Fuxenstunden</h4>
                                <h5>TBA</h5>
                            </div>
                        </div>
                        */}
                    </Col>
                </Row>
            </Container>
        </section>

    )
}